export default __webpack_public_path__ + "static/media/linked.d22a1dc2.svg";